import React from "react";
import { APPLY_CARD_FLYER, APPLY_CARD_PHOTO } from "../assets/images";

function ApplyCards({ onApplyClick }) {
  const cards = [
    { src: APPLY_CARD_FLYER, alt: "Apply by SMS – Chanuka Bursary" },
    { src: APPLY_CARD_PHOTO, alt: "Apply by SMS – Chanuka Bursary" },
  ];

  return (
    <div className="mx-auto mt-8 w-full max-w-4xl px-1 sm:px-2">
      <div className="grid grid-cols-2 gap-5 sm:gap-6 md:gap-8">
        {cards.map((card) => (
          <button
            key={card.src}
            type="button"
            onClick={onApplyClick}
            className="group flex aspect-3/4 min-h-0 items-center justify-center overflow-hidden rounded-xl border border-slate-200 bg-slate-100 shadow-md transition hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-[#0057A5] focus:ring-offset-2 disabled:opacity-70"
          >
            <img
              src={card.src}
              alt={card.alt}
              className="max-h-full max-w-full object-contain object-center transition group-hover:scale-[1.02]"
            />
          </button>
        ))}
      </div>
    </div>
  );
}

export default ApplyCards;
